import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {APIError} from '~common/lib/types';
import BulletinList from '~common/components/bulletin-lister'; 
import Renderers from '~common/lib/renderers';

const styles = (theme: Theme): StyleRules => ({
  container: {
    flex: 1,
  },
  taskCard: {
    width: '100%',
    background: theme.palette.background.paper,
    border: '1px solid #ccc',
    minHeight: 200
  },
  caption: {
    textAlign: 'center',
    borderBottom: '1px solid #ccc',
    padding: 10
  },
  cardContent: {
    margin: '10px 15px 10px 15px'
  },
  countContent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    cursor: 'pointer'
  },
  templateContent: {
    minHeight: 120
  },
  cardContentEven: {
    margin: '10px 15px 10px 15px',
    display: 'flex',
    justifyContent: 'space-around'
  },
  cardActions: {
    padding: 5
  },
  bulletinWrapper: {
    flex: 1,
    height: "100%"
  }

});

interface Props {
  id: number;
  caption: string;
  renderers: any;
  element: any;

  chromeless?: boolean;
}

type State = {
  status: 'loading' | 'ready';
  data: any;
  error?: any;
};

class BulletinsRenderer extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      data: null
    };
  }

  // UNSAFE_componentWillReceiveProps(
  //   newProps: Props & WithStyles<keyof typeof styles>
  // ) {}

 componentDidMount() {
    const self = this;
    if (!this.props.element || !this.props.element.id) {
      console.error("No ID found on Props")
    } else {
    // console.log("Requesting: ", this.props.element.id)
    request
      .get('/api/dashboards/' + this.props.element.id)
      .set('accept', 'application/json')
      .send()
      .then((response) => {
        self.setState({status: 'ready', data: response.body});
      })
      .catch((err) => {
        if (err.response && err.response.text) {
          const apiErr = new APIError();
          apiErr.type = 'http';
          apiErr.message = err.response.text;
          self.setState({status: 'ready', error: apiErr});
        }
      });
    }
  }

  static register = () => {
    // console.log("Registering BulletinElementRenderer")
    if(!Renderers.find("BulletinElementRenderer")){
      // console.log("Registering BulletinElementRenderer")
      Renderers.register("BulletinElementRenderer", withStyles(styles)(BulletinsRenderer))
    }
  }

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {chromeless, renderers} = this.props;
    const {status, data} = this.state;
        
    var cardClass:string = "";
    if(classes){
      cardClass = classes.cardContent;
    }

    var cardContent: any = null; 

    switch (status) {
      case 'loading':
        return (
          <div className={classes.container}>
            <LoadingView compact classes={{}} />
          </div>
        );

      default:
        if (
            data &&
            data.content &&
            data.content.results &&
            data.content.results.items
          ) {
          cardContent = (
            <BulletinList
              chromeless
              classes={{}}
              bulletins={data.content.results.items}
            />
          );
        }
    }


    return <div className={classes.bulletinWrapper}>{cardContent}</div>;
  }
}

export default withStyles(styles)(BulletinsRenderer);

